import { HUB_SITE_URL } from "./hubApi";
export async function fetchLandingData(payload, signal) {
  const response = await fetch(
    `${HUB_SITE_URL}/.netlify/functions/tol-leagues`,
    {
      method: "POST",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal,
    }
  );
  if (!response.ok) throw new Error("League data unavailable");
  const data = await response.json();
  if (!data.ok) throw new Error("League data unavailable");
  return data;
}
export function landingLeagueDetails(payload) {
  const ranking = payload?.results?.["league/ranking"];
  const fixtures = payload?.results?.["league/fixtures"];
  const table =
    ranking?.ok && Array.isArray(ranking.data) ? ranking.data : null;
  const matches =
    fixtures?.ok && Array.isArray(fixtures.data?.matches)
      ? fixtures.data.matches.flatMap((day) =>
          (day.matches || []).map((match) => ({
            ...match,
            date: day.match_date,
          }))
        )
      : null;
  return {
    table,
    matches:
      matches
        ?.filter(
          (match) =>
            Number.isFinite(match.home_goals) &&
            Number.isFinite(match.away_goals)
        )
        .sort((a, b) => new Date(b.date) - new Date(a.date)) ||
      (matches ? [] : null),
  };
}
